import app_2 from '@/public/features/payment_management/Frame-1171279152.webp';
import bg from '@/public/features/payment_management/Main.webp';

const intro = {
  tag: '',
  description: `Simplify your financial transactions using our comprehensive payment management system. Whether you're processing credit cards, ACH payments, or managing tips and balances, our platform ensures secure transactions and efficient financial tracking.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Handle Payments Effortlessly',
  second_title: '  with\xa0Our Payment Management',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What is Payment Management?`,
  },
  title: `What is Payment Management?`,
  description: `Payment management is a crucial feature for businesses, which allows you to process credit cards and ACH payments seamlessly with competitive rates. It also enables easy management of tips and provides real-time tracking of balance statuses, ensuring smooth financial operations.`,
  item: [
    {
      title: 'Secure payment processing',
      description:
        'Process credit cards and ACH payments securely and efficiently using our platform, which offers competitive rates to help you save on transaction costs.',
    },
    {
      title: 'Tip management',
      description:
        'Enable customers to add tips directly to their payments, enhancing customer satisfaction and rewarding your service professionals for exceptional service.',
    },

    {
      title: 'Balance tracking',
      description: `Effortlessly manage and track payment balances in real-time. Monitor transaction statuses and ensure accurate financial records to maintain business efficiency and transparency.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
